import { Directive, ElementRef, HostListener, Input, NgModule } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
var NgxAutoScroll = (function () {
    /**
     * @param {?} element
     */
    function NgxAutoScroll(element) {
        this.lockYOffset = 10;
        this.observeAttributes = "false";
        this._isLocked = false;
        this.nativeElement = element.nativeElement;
    }
    /**
     * @return {?}
     */
    NgxAutoScroll.prototype.getObserveAttributes = function () {
        return this.observeAttributes !== "" && this.observeAttributes.toLowerCase() !== "false";
    };
    /**
     * @return {?}
     */
    NgxAutoScroll.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.mutationObserver = new MutationObserver(function () {
            if (!_this._isLocked) {
                _this.scrollDown();
            }
        });
        this.mutationObserver.observe(this.nativeElement, {
            childList: true,
            subtree: true,
            attributes: this.getObserveAttributes(),
        });
    };
    /**
     * @return {?}
     */
    NgxAutoScroll.prototype.ngOnDestroy = function () {
        this.mutationObserver.disconnect();
    };
    /**
     * @return {?}
     */
    NgxAutoScroll.prototype.forceScrollDown = function () {
        this.scrollDown();
    };
    /**
     * @return {?}
     */
    NgxAutoScroll.prototype.isLocked = function () {
        return this._isLocked;
    };
    /**
     * @return {?}
     */
    NgxAutoScroll.prototype.scrollDown = function () {
        this.nativeElement.scrollTop = this.nativeElement.scrollHeight;
    };
    /**
     * @return {?}
     */
    NgxAutoScroll.prototype.scrollHandler = function () {
        var /** @type {?} */ scrollFromBottom = this.nativeElement.scrollHeight - this.nativeElement.scrollTop - this.nativeElement.clientHeight;
        this._isLocked = scrollFromBottom > this.lockYOffset;
    };
NgxAutoScroll.ɵfac = function NgxAutoScroll_Factory(t) { return new (t || NgxAutoScroll)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxAutoScroll.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgxAutoScroll, selectors: [["", "ngx-auto-scroll", ""]], hostBindings: function NgxAutoScroll_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function NgxAutoScroll_scroll_HostBindingHandler() { return ctx.scrollHandler(); });
    } }, inputs: { lockYOffset: ["lock-y-offset", "lockYOffset"], observeAttributes: ["observe-attributes", "observeAttributes"] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxAutoScroll, [{
        type: Directive,
        args: [{
                selector: "[ngx-auto-scroll]"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { lockYOffset: [{
            type: Input,
            args: ["lock-y-offset"]
        }], observeAttributes: [{
            type: Input,
            args: ["observe-attributes"]
        }], scrollHandler: [{
            type: HostListener,
            args: ["scroll"]
        }] }); })();
    return NgxAutoScroll;
}());
/**
 * @nocollapse
 */
NgxAutoScroll.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NgxAutoScroll.propDecorators = {
    'lockYOffset': [{ type: Input, args: ["lock-y-offset",] },],
    'observeAttributes': [{ type: Input, args: ["observe-attributes",] },],
    'scrollHandler': [{ type: HostListener, args: ["scroll",] },],
};
var NgxAutoScrollModule = (function () {
    function NgxAutoScrollModule() {
    }
NgxAutoScrollModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxAutoScrollModule });
NgxAutoScrollModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxAutoScrollModule_Factory(t) { return new (t || NgxAutoScrollModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxAutoScrollModule, { declarations: [NgxAutoScroll], exports: [NgxAutoScroll] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxAutoScrollModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxAutoScroll],
                imports: [],
                exports: [NgxAutoScroll]
            }]
    }], function () { return []; }, null); })();
    return NgxAutoScrollModule;
}());
/**
 * @nocollapse
 */
NgxAutoScrollModule.ctorParameters = function () { return []; };
/**
 * Generated bundle index. Do not edit.
 */
export { NgxAutoScroll, NgxAutoScrollModule };

//# sourceMappingURL=ngx-auto-scroll.es5.js.map